module.exports = __webpack_public_path__ + "img/31.54775a51.png";